<template>
  <div>
    <spacer size="l"></spacer>

    <masked-input
      v-model="model.no"
      name="card_number"
      icon="credit_card"
      :label="$vuetify.lang.t('$vuetify.account.cardNumber')"
      v-mask="'####-####-####-####'"
      required
      outlined
      :error-messages="fieldErrors.no"
      @input="fieldErrors.no = null"
    ></masked-input>
    <spacer size="m"></spacer>

    <masked-input
      v-model="model.name"
      icon="person"
      name="name_on_card"
      :label="$vuetify.lang.t('$vuetify.account.nameOnCard')"
      required
      outlined
      :error-messages="fieldErrors.name"
      @input="fieldErrors.name = null"
    ></masked-input>
    <spacer size="m"></spacer>

    <div class="d-flex flex-row justify-content-between gap-8">
      <masked-input
        v-model="model.expired"
        name="card_exp"
        prepend-inner-icon="event"
        :label="$vuetify.lang.t('$vuetify.account.mmyy')"
        v-mask="'## / ##'"
        required
        outlined
        class="flex-1"
        :error-messages="fieldErrors.expiredMonth"
        @input="fieldErrors.expiredMonth = null"
      ></masked-input>

      <masked-input
        v-model="model.csv"
        name="card_cvc"
        prepend-inner-icon="event"
        :label="$vuetify.lang.t('$vuetify.account.cvc')"
        v-mask="'####'"
        required
        outlined
        class="flex-1"
        :error-messages="fieldErrors.csv"
        @input="fieldErrors.csv = null"
      ></masked-input>
    </div>

    <spacer size="m"></spacer>

    <div class="d-flex flex-row justify-content-between gap-8 ">
      <v-autocomplete
        class="flex-1 position-relative"
        v-model="selectedCountry"
        icon="place"
        :items="countries"
        item-text="country"
        required
        :height="52"
        filled
        rounded
        :error-messages="fieldErrors.country"
        :label="$vuetify.lang.t('$vuetify.account.country')"
        return-object
        :rules="[() => !!selectedCountry || 'This field is required']"
        @change="handleCountryChange"
      ></v-autocomplete>
      <masked-input
        class="flex-1"
        v-model="model.postalCode"
        name="card_postalCode"
        v-mask="parseMask(selectedCountry.format)"
        icon="place"
        :label="
          $vuetify.lang.current === 'zhHans'
            ? '邮编'
            : selectedCountry.name || 'Postal Code'
        "
        required
        outlined
        :error-messages="fieldErrors.postalCode"
        @input="fieldErrors.postalCode = null"
      ></masked-input>
    </div>

    <div
      v-if="!selectedCountry.format"
      style="font-size: 12px; text-align: left;"
    >
      {{ $vuetify.lang.t("$vuetify.account.otherPostalCode") }}
    </div>
  </div>
</template>

<script>
import { countries } from "../../countries.js";
import { get } from "lodash";
import { mapGetters, mapActions } from "vuex";
import MaskedInput from "./maskedInput.vue";
import Spacer from "./Spacer.vue";
export default {
  components: {
    MaskedInput,
    Spacer,
  },
  data() {
    return {
      dialogModel: false,
      source: null,

      model: {
        name: "",
        no: "",
        expired: "",
        expiredMonth: "",
        expiredYear: "",
        csv: "",

        country: "",
        postalCode: "",
      },

      selectedCountry: {},
      countries: countries,
      fieldErrors: {},
    };
  },

  computed: {
    ...mapGetters(["getBuild"]),
  },

  methods: {
    parseMask(format) {
      if (format) return format.split(" or ");
      return "XXXXXXXXXXXXXXXXXXXX";
    },

    /**
      Save card information and return true if successful, false otherwise
      @returns {Promise<boolean>}
     */
    saveCard() {
      return new Promise((resolve) => {
        let error = false;

        const { no, name, expired = "0000", csv } = this.model;

        const expiredMonth = expired.substring(0, 2);
        const expiredYear = expired.substring(5, 7);

        const payload = {
          name,
          no,
          expiredMonth,
          expiredYear,
          csv,
          postalCode: (this.model.postalCode || "")
            .replace(/-/g, "")
            .replace(/ /g, ""),
          country: this.selectedCountry.code,
        };

        for (let field in payload) {
          // All fields are required but postalcode which is conditional
          if (!payload[field]) {
            this.$set(this.fieldErrors, field, `${field} is required`);
            error = true;
            this.$forceUpdate();
          }
        }

        // 如果本地校验失败，直接结束，不发请求
        if (error) {
          resolve(false);
          return;
        }

        this.$api
          .post("/owa/customer/paymentMethod", payload)
          .then(() => {
            this.dialogModel = false;
            resolve(true);
          })
          .catch((error) => {
            const errorMsg =
              get(error, "res.data.errorMsg") ||
              get(error, "response.data.errorMsg");
            const errorCode =
              get(error, "res.data.errorCode") ||
              get(error, "response.data.errorCode");
            const message = errorMsg || errorCode;

            if (message)
              this.$bus.$emit("showAlert", ("" + message).split("code:")[0]);

            resolve(false);
          });
      });
    },

    handleCountryChange() {
      this.model.postalCode = null;
      this.fieldErrors.country = null;
      this.fieldErrors.postalCode = null;
    },

    ...mapActions(["setAddPaymentMethodDialog", "addPaymentMethod"]),
  },

  watch: {
    dialogModel() {
      this.fieldErrors = {};

      // Clear the form whenever the dialog closes
      if (!this.dialogModel) {
        for (let field in this.model) this.model[field] = "";
      } else {
        // Default the selected store to the store country
        const storeCountry = get(this.getBuild, "country", "CA");
        this.selectedCountry =
          this.countries.find((country) => country.code == storeCountry) || {};
        this.$parent.fetchPaymentMethods();
      }
    },
  },
};
</script>

<style scoped></style>
